<template>
  <BaseDialog
    :is-open="isOpen"
    :title="$t('coaching.feedbackGoals.deleteDialog.title')"
    type="basic"
    :description="$t('coaching.feedbackGoals.deleteDialog.description')"
    @close="emit('close')"
  >
    <template #dismiss>
      <BaseTextButton color="text" size="M" @click="emit('close')">
        {{ $t('common.cancel') }}
      </BaseTextButton>
    </template>
    <template #confirm>
      <BaseTextButton color="text" size="M" @click="emit('delete-goal')">
        {{ $t('coaching.feedbackGoals.deleteDialog.action') }}
      </BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'

  interface Props {
    isOpen: boolean
  }

  defineProps<Props>()

  const emit = defineEmits<{
    (e: 'close'): void
    (e: 'delete-goal'): void
  }>()
</script>
